.compositionLabelRow {
  display: flex;
  justify-content: space-between;
}

.compositionLabel {
  font-weight: 700;
  color: var(--hcr-content-primary-color);
}

.composition {
  display: flex;
  flex-wrap: wrap;
  gap: var(--hcr-spacing-2);
  padding: var(--hcr-spacing-2);
  border: 1px dashed var(--hcr-line-primary-color);
  border-radius: var(--hcr-border-radius-2);
}

.compositionEmpty {
  justify-content: center;
  color: var(--hcr-content-secondary-color);
}

.emptyState {
  display: flex;
  align-items: center;
  gap: var(--hcr-spacing-1);
  min-height: var(--hcr-spacing-5);
}

.compositionOver {
  border-color: var(--hcr-success-color);
  background-color: var(--hcr-highlight-color);
}

.endInsertBar {
  display: inline-block;
  align-self: stretch;
  width: 2px;
  border-radius: 1px;
  background-color: var(--hcr-success-color);
}
